// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type GetTasksByModuleParams = {
  user_id?: string | null;
  course_id?: string | null;
  include?: string | null;
  as_admin?: unknown;
  version?: number | null;
  page?: number;
  pageSize?: number;
  sort?: string;
  filter?: string;
};
